import { render, staticRenderFns } from "./courseYqjxps.vue?vue&type=template&id=6c8eb8ad&scoped=true&"
import script from "./courseYqjxps.vue?vue&type=script&lang=js&"
export * from "./courseYqjxps.vue?vue&type=script&lang=js&"
import style0 from "./courseYqjxps.vue?vue&type=style&index=0&id=6c8eb8ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8eb8ad",
  null
  
)

export default component.exports